'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { scrollToHash } from '@/helpers/scrollToHash';
const MAX_ATTEMPTS = 100;
const RETRY_INTERVAL_MS = 50;
export const useHashScrollOnLoad = pathname => {
  const $ = _c(2);
  let t0;
  if ($[0] !== pathname) {
    t0 = [pathname];
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp, t0);
};
function _temp() {
  const hash = window.location.hash;
  if (!hash) {
    return;
  }
  let cancelled = false;
  let intervalId;
  const attempt = () => !cancelled && scrollToHash(hash);
  const startRetry = () => {
    if (attempt()) {
      return;
    }
    let attempts = 0;
    intervalId = setInterval(() => {
      if (attempt()) {
        clearInterval(intervalId);
        return;
      }
      attempts = attempts + 1;
      attempts;
      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(intervalId);
      }
    }, RETRY_INTERVAL_MS);
  };
  startRetry();
  const onLoad = () => attempt();
  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
  return () => {
    cancelled = true;
    clearInterval(intervalId);
    window.removeEventListener("load", onLoad);
  };
}